import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {S3} from 'aws-sdk';
import {FuseDeleteDialogComponent} from '../delete-dialog/delete-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {DocumentsService} from '../../services/documents.service';

@Component({
    selector: 'uploader',
    templateUrl: './uploader.component.html',
    styleUrls: ['./uploader.component.scss'],
    standalone: false
})

export class UploaderComponent implements OnChanges {
  @Input() uploadedFiles;
  @Input() formElementId;
  @Output() loadedFiles = new EventEmitter();

  public files = [];

  progressBar = 0;
  startProgress = false;
  progressFail = false;
  progressDone = false;

  constructor(public dialog: MatDialog, private documentService: DocumentsService) {
  }

  ngOnChanges(changes) {
    if (this.uploadedFiles && this.uploadedFiles.length) {
      for (let item of this.uploadedFiles) {
        item.url = item.name;
        item.type = item.name.substring(item.name.lastIndexOf('.') + 1 , item.name.length);
        item.name = item.name.split('|_|')[ 1 ];
      }
    }
  }

  handleInputChangeDoc(event: any) {
    event.preventDefault();
    this.uploadFileFunc(event.target.files[0]);
  }

  getVideo(name) {
    return this.documentService.getVideoStream(name);
  }

  uploadFileFunc(file) {
    let date = new Date();
    console.log('start', date.getTime());
    this.startProgress = true;
    const fileNameSplit = file.name.split('.');
    const contentType = fileNameSplit[fileNameSplit.length - 1];
    const bucket = new S3(
      {
        region: 'us-east-2'
      }
    );
    let fileName = Date.now().toString() + '|_|' + file.name;
    const params = {
      Bucket: 'pfefferstern/videos',
      Key: fileName,
      Body: file,
      ACL: 'public-read',
      ContentType: contentType
    };
    let that = this;
    bucket.upload(params).on('httpUploadProgress', function (evt) {
      that.progressBar = +Math.floor(evt.loaded * 100 / evt.total);
      console.log(that.progressBar);
      console.log(evt.loaded + ' of ' + evt.total + ' Bytes');
    }).send(function (err, data) {
      if (err) {
        that.progressFail = true;
        console.log('There was an error uploading your file: ', err);
        return false;
      }
      let obj = {
        name: fileName,
        fileName: file.name,
        type: 'elearning',
        publicAccess: true,
        storageType: 'video',
        fileType: contentType,
        url: fileName
      };
      that.files.push(obj);
      that.loadedFiles.emit(that.files);
      that.progressDone = true;
      let date1 = new Date();
      console.log('finish', date1.getTime());
      setTimeout(() => {
        that.startProgress = false;
      }, 2000);
      console.log('Successfully uploaded file.', data);
      return true;
    });
  }

  removeFile (e) {
    const index = this.files.indexOf(e);
    if (index > -1) {
      this.files.splice(index, 1);
    }
  }


  removeFileFromUpload (e) {
    // console.log(e);
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'Delete' , message: 'deleteConfirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const index = this.uploadedFiles.indexOf(e);
        if (index > -1) {
          this.uploadedFiles.splice(index , 1);
        }
        this.documentService.deleteDocument(e.id).subscribe((res) => {
          if (res) {

          }
        });
      }
    });

  }
}
